import BaseAPIClient from "../base/BaseAPIClient";

export default class SessionReportsClient extends BaseAPIClient {

  getUserDemographics(schoolId, customCampusTags) {
    return this._get('v2/campus-administration/reports/user-demographics/', {
      schoolId,
      customCampusTags,
    });
  }
}